/* ================================================================
   FARM SUPPLIEZ — THEME JS
   ================================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── FAQ Accordion ──────────────────────────────────────────────
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.faq-item').forEach(function (el) { el.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── Product Image Gallery ──────────────────────────────────────
  var mainImg = document.querySelector('.gallery-main-img');
  document.querySelectorAll('.gallery-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.gallery-thumb').forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
      if (mainImg) {
        var src = this.dataset.src;
        if (src) mainImg.src = src;
      }
    });
  });

  // ── Product Tab Switching ──────────────────────────────────────
  document.querySelectorAll('.tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = this.dataset.tab;
      document.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
      document.querySelectorAll('.tab-pane').forEach(function (p) { p.classList.remove('active'); });
      this.classList.add('active');
      var pane = document.getElementById(target);
      if (pane) pane.classList.add('active');
    });
  });

  // ── Variant Selector ──────────────────────────────────────────
  document.querySelectorAll('.variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = this.closest('.variant-options');
      if (group) {
        group.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('active'); });
      }
      this.classList.add('active');
    });
  });

  // ── Quantity Selector ─────────────────────────────────────────
  document.querySelectorAll('.qty-selector, .qty-control').forEach(function (selector) {
    var minus = selector.querySelector('.qty-btn-minus, button:first-child');
    var plus = selector.querySelector('.qty-btn-plus, button:last-child');
    var input = selector.querySelector('.qty-input, .qty-display');
    if (!minus || !plus || !input) return;
    minus.addEventListener('click', function () {
      var val = parseInt(input.textContent || input.value) || 1;
      if (val > 1) {
        if (input.tagName === 'INPUT') input.value = val - 1;
        else input.textContent = val - 1;
      }
    });
    plus.addEventListener('click', function () {
      var val = parseInt(input.textContent || input.value) || 1;
      if (input.tagName === 'INPUT') input.value = val + 1;
      else input.textContent = val + 1;
    });
  });

  // ── Cart Remove ───────────────────────────────────────────────
  document.querySelectorAll('.remove-link').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.cart-item');
      if (item) {
        item.style.transition = 'opacity 0.3s';
        item.style.opacity = '0';
        setTimeout(function () { item.remove(); }, 300);
      }
    });
  });

  // ── Discount Toggle ───────────────────────────────────────────
  var discountToggle = document.querySelector('.discount-toggle');
  var discountForm = document.querySelector('.discount-form');
  if (discountToggle && discountForm) {
    discountForm.style.display = 'none';
    discountToggle.addEventListener('click', function () {
      discountForm.style.display = discountForm.style.display === 'none' ? 'flex' : 'none';
    });
  }

  // ── Mobile menu drawer ────────────────────────────────────────
  var menuToggle = document.querySelector('.mobile-menu-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  var backdrop = document.querySelector('.mobile-nav-backdrop');
  var menuClose = document.querySelector('.mobile-nav__close');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (backdrop) { backdrop.hidden = false; requestAnimationFrame(function(){ backdrop.classList.add('is-open'); }); }
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mobile-nav-open');
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (backdrop) { backdrop.classList.remove('is-open'); setTimeout(function(){ backdrop.hidden = true; }, 220); }
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-nav-open');
  }
  if (menuToggle) menuToggle.addEventListener('click', openMobileNav);
  if (menuClose) menuClose.addEventListener('click', closeMobileNav);
  if (backdrop) backdrop.addEventListener('click', closeMobileNav);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('is-open')) closeMobileNav();
  });

  // ── Sticky header shadow on scroll ───────────────────────────
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 12px rgba(0,0,0,0.1)';
      } else {
        header.style.boxShadow = '0 1px 4px rgba(0,0,0,0.04)';
      }
    }, { passive: true });
  }

  // ── Cart badge count ──────────────────────────────────────────
  function updateCartBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('.cart-badge');
        if (badge) badge.textContent = cart.item_count;
      })
      .catch(function () {});
  }
  updateCartBadge();

  // ── Global Add to Cart (used by product cards on collection/home pages) ─
  window.addToCart = function (variantId, btn) {
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.textContent = 'Added!'; }
        updateCartBadge();
        setTimeout(function () {
          if (btn) { btn.textContent = orig; btn.disabled = false; }
        }, 2000);
      })
      .catch(function () {
        if (btn) { btn.textContent = orig; btn.disabled = false; }
      });
  };

  // ── Add to Cart ───────────────────────────────────────────────
  var atcForm = document.querySelector('.atc-form');
  if (atcForm) {
    atcForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = this.querySelector('.btn-atc');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
      var formData = new FormData(this);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (btn) { btn.textContent = 'Added!'; }
          updateCartBadge();
          setTimeout(function () {
            if (btn) { btn.textContent = originalText; btn.disabled = false; }
          }, 2000);
        })
        .catch(function () {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
        });
    });
  }

  // Newsletter form: submit naturally to Shopify (/contact). Showing a success state
  // is handled server-side via the customer_posted flag rendered in the section.

});
